import { t } from '../i18n';

/**
 * Tiny relative-time formatter — "Just updated", "Updated 12s ago",
 * "Updated 4 min ago". We keep the granularity coarse on purpose:
 * the watcher doesn't need second-precision past the first minute,
 * and the connection pill carries the staleness signal at longer
 * timescales.
 */
export function formatLastUpdate(timestamp: Date | string | null | undefined, now: number = Date.now()): string {
  if (!timestamp) return '';
  const then = timestamp instanceof Date ? timestamp.getTime() : new Date(timestamp).getTime();
  if (Number.isNaN(then)) return '';
  const diffSeconds = Math.max(0, Math.floor((now - then) / 1000));
  if (diffSeconds < 3) return t('stats.justUpdated');
  if (diffSeconds < 60) return t('stats.lastUpdate', { seconds: diffSeconds });
  const diffMinutes = Math.floor(diffSeconds / 60);
  return t('stats.lastUpdateMin', { minutes: diffMinutes });
}
